export default "__VITE_ASSET__51188d88__"